import React from "react";
import Thread from "graphics/icons/BranchBar/Thread";
import {
  APP_CODE_BRANCH,
  APP_CODE_TEXT_CHANNEL,
  APP_CODE_ROOM,
} from "constants/constants";
import BranchOpen from "graphics/icons/BranchBar/BranchOpen";
import BranchClosed from "graphics/icons/BranchBar/BranchClosed";
import TextChannel from "graphics/icons/BranchBar/TextChannel";
import SpaceIcon from "graphics/icons/BranchBar/SpaceIcon";

const AppIcon = ({ appId, isOpen = false }) => {
  switch (appId) {
    case APP_CODE_BRANCH:
      return isOpen ? <BranchOpen /> : <BranchClosed />;
    case APP_CODE_TEXT_CHANNEL:
      return <TextChannel />;
    case APP_CODE_ROOM:
      return <SpaceIcon />;
    default:
      return <Thread />;
  }
};

export default AppIcon;
